import React, {Component} from 'react';

class ErrorBoundary extends Component {

    state = {hasError: false, error: {}};

    componentDidCatch = (error, info) => {
        this.setState({error, hasError: true});
    };

    render() {
        return (
            this.state.hasError === true ?
                <div>
                    something went wrong
                </div> :
                this.props.children
        );
    }
}

ErrorBoundary.propTypes = {};

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/component/alert/ErrorBoundary.jsx